import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TrendingUp, PieChart, FileText } from "lucide-react";
import Trends from "./Trends";
import Insights from "./Insights";
import Reports from "./Reports";
import { motion } from "framer-motion";

const Analytics = () => {
  return (
    <div className="container mx-auto px-4 py-6 max-w-7xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="space-y-6"
      >
        <div className="flex items-center gap-4">
          <div className="p-3 bg-gradient-to-br from-primary/20 to-cyan/20 rounded-xl">
            <TrendingUp className="h-6 w-6 text-primary-text" />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Analytics</h1>
            <p className="text-sm text-muted-foreground">
              Track trends, insights, and generate reports
            </p>
          </div>
        </div>

        <Tabs defaultValue="insights" className="w-full">
          <TabsList className="grid w-full max-w-lg grid-cols-3">
            <TabsTrigger value="insights" className="flex items-center gap-2">
              <PieChart className="h-4 w-4" />
              Insights
            </TabsTrigger>
            <TabsTrigger value="trends" className="flex items-center gap-2">
              <TrendingUp className="h-4 w-4" />
              Trends
            </TabsTrigger>
            <TabsTrigger value="reports" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Reports
            </TabsTrigger>
          </TabsList>
          <TabsContent value="insights" className="mt-6">
            <InsightsContent />
          </TabsContent>
          <TabsContent value="trends" className="mt-6">
            <TrendsContent />
          </TabsContent>
          <TabsContent value="reports" className="mt-6">
            <ReportsContent />
          </TabsContent>
        </Tabs>
      </motion.div>
    </div>
  );
};

// Embedded versions without their own headers
const InsightsContent = () => {
  return <div className="-mt-6"><Insights /></div>;
};

const TrendsContent = () => {
  return <div className="-mt-8"><Trends /></div>;
};

const ReportsContent = () => {
  return <div className="-mt-8"><Reports /></div>;
};

export default Analytics;
